import { useState, useEffect } from "react";
import ChatLayout from "./components/ChatLayout";
import MessageList from "./components/MessageList";
import ChatInput from "./components/ChatInput";
import VoiceModal from "./components/VoiceModal";
import InstructionModal from "./components/InstructionModal";
import ConfirmOrderModal from "./components/ConfirmOrderModal";
import Header from "./components/Header";
import { createStyles, themes } from "./styles";
import { useChat } from "./hooks/useChat";
import { useViewport } from "./hooks/useViewport";

export default function ChatPage({ restaurant, table }) {
    useViewport();

    const theme = themes.dark;
    const styles = createStyles(theme);

    // Save restaurant and table info to localStorage for AuthHeader
    useEffect(() => {
        if (restaurant) {
            localStorage.setItem('currentRestaurant', JSON.stringify(restaurant));
        }
        if (table) {
            localStorage.setItem('currentTable', table.toString());
        }
    }, [restaurant, table]);

    const {
        userId,
        messages,
        input,
        setInput,
        loading,
        sendMessage,
        resetChat,
        addMessages,
        preparedOrder,
        showConfirmModal,
        handleConfirmOrder,
        handleDeclineOrder,
    } = useChat(restaurant, table);

    const [isVoiceModalOpen, setIsVoiceModalOpen] = useState(false);
    const [isInstructionModalOpen, setIsInstructionModalOpen] = useState(false);
    const [showInitialInstructions, setShowInitialInstructions] = useState(messages.length === 0);

    // Show/hide initial instructions based on messages
    useEffect(() => {
        setShowInitialInstructions(messages.length === 0);
    }, [messages.length]);

    const handleSendMessage = async () => {
        await sendMessage();
    };

    const handleReset = () => {
        resetChat();
    };

    return (
        <ChatLayout pageStyle={styles.page} containerStyle={styles.container}>
            <Header
                restaurant={restaurant}
                table={table}
                onOpenVoice={() => setIsVoiceModalOpen(true)}
                onReset={handleReset}
                onOpenInstructions={() => setIsInstructionModalOpen(true)}
                styles={styles}
            />

            <MessageList
                messages={messages}
                chatBoxStyle={styles.chatBox}
                styles={styles}
                theme={theme}
                showInitialInstructions={showInitialInstructions}
            />

            <ChatInput
                value={input}
                onChange={setInput}
                onSend={handleSendMessage}
                disabled={loading}
                inputRowStyle={styles.inputRow}
                inputStyle={styles.input}
                buttonStyle={{
                    ...styles.button,
                    ...(loading ? styles.disabledButton : null),
                }}
            />

            <VoiceModal
                isOpen={isVoiceModalOpen}
                onClose={() => setIsVoiceModalOpen(false)}
                theme={theme}
                restaurant={restaurant}
                userId={userId}
                table={table}
                onAddMessages={addMessages}
            />

            <InstructionModal
                isOpen={isInstructionModalOpen}
                onClose={() => setIsInstructionModalOpen(false)}
                theme={theme}
                allowOutsideClick={true}
            />

            <ConfirmOrderModal
                isOpen={showConfirmModal}
                onConfirm={handleConfirmOrder}
                onDecline={handleDeclineOrder}
                theme={theme}
                preparedOrder={preparedOrder}
            />
        </ChatLayout>
    );
}
